import { render } from "./index.vue?vue&type=template&id=92f181aa"
const script = {}

import exportComponent from "C:\\Users\\yrabie\\Documents\\Projects\\Awsat Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__